export default __webpack_public_path__ + "static/media/voting-popup.0ad363d0.png";